/* reason for this soluttion: could be done without CSS implied */
import breakpoint from 'constants/breakpoint';

const getBreakpoint = (): string => {
    // console.log('getBP');
    let bp = 'sm';
    Object.keys(breakpoint).forEach((key) => {
        const obj = (breakpoint as Record<string, { width: any }>)[key];
        const str = '(min-width:' + obj.width + ')';
        if (window.matchMedia(str).matches) {
            bp = key;
        }
    });
    return bp;
}

export default getBreakpoint;
